(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Client.Cases",
                {
                    url: "/Cases",
                    component: "cases",
                    data: {
                        pageTitle: "Cases"
                    }
                });
        }
    ]);

    app.component("cases",
        {
            templateUrl: "/App/Client/Cases/cases.template.html",
            controller: casesController,
            bindings: {
                client: "<"
            }
        });

    casesController.$inject = ['caseModalService', 'caseApi', '$filter', 'figToaster'];

    function casesController(caseModalService, caseApi, $filter, figToaster) {
        var $ctrl = this;

        const getClientCaseAndAccountList = (clientId) => {
           return caseApi.getClientCaseAndAccountList(clientId).then(response => {
                $ctrl.caseAccountList = response;
                $ctrl.loading = false;
            });
        };


        $ctrl.addCase = $event => {
            return caseModalService.openAddCase($ctrl.client, $event);
        }

        $ctrl.deleteCase = (caseId, index, $event) => {
            $ctrl.caseAccountList = $filter('orderBy')($ctrl.caseAccountList, $ctrl.selected.value, $ctrl.reverseSort);
            caseModalService.confirmCaseDeletion($event)
                .then(() => {
                    caseApi.deleteCase(caseId);
                })
                .then(() => {
                    $ctrl.caseAccountList.splice(index, 1);
                    figToaster.showSimple("Case deleted.", "top");
                })
                .catch(() => figToaster.showError("There was a problem deleting your case. Please try again.", "top"));
        };

        $ctrl.sortRows = selected => {
            $ctrl.reverseSort = ($ctrl.selected.value === selected.value) ? !$ctrl.reverseSort : false;
            $ctrl.selected = selected;
        };

        $ctrl.$onInit = () => {
            $ctrl.sortOptions = [
                {
                    value: 'CaseDate',
                    name: 'Case Date'
                },
                {
                    value: 'CaseName',
                    name: 'Case Name'
                }
            ];
            $ctrl.loading = true;
            $ctrl.selected = $ctrl.sortOptions[0];
            $ctrl.reverseSort = true;
            getClientCaseAndAccountList($ctrl.client.Id);
        };
    }

})(window.app, window.angular); //jshint ignore:line